<!-- 案例中心 -->
<template>
    <div>
      <!-- <div class="header_img"></div> --> 
      <sub-banner id="id_about">
        <img src="../../assets/images/case/case_top.png"/>
      </sub-banner>
      <div class="case_content">
          <!-- <div class="case_title_btn_group">
              <div class="pc_btn" :class="activeItem=='pc'?'active_btn':''" @click="clickItem('pc')">PC建站</div>
              <div class="small_min_btn" :class="activeItem=='minapp'?'active_btn':''" @click="clickItem('minapp')">小程序</div>
          </div> -->
          <div class="case_title_tip">{{$t('case.case_title')}}</div>
          <div class="case_title_tip_t">{{$t('case.case_descript')}}</div>
          <!-- <el-row>  -->
          <div class="case_flex_card">
               <div class="case_item" ref="cardListWrap">
                    <div v-for="(o, index) in caseData" :key="o.id" shadow="always" class="item_info" >
                        <el-card :body-style="{ padding: '0px' }">
                            <img :src="o.img_src" class="image_card">
                            <div class="card_content">
                                <div class="card_title">{{o.title}}</div>
                                <div class="card_title_t">{{o.desc}}</div>
                            </div>
                            <div class="card_desc">
                                <div class="desc_text">{{o.type}}</div>
                            </div>
                        </el-card>
                    </div>
                    <div class="item_info"  v-for="item in lastRowBlankColumn" :key='item+"_p"'></div>
                </div>
          </div>
      </div>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'

import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-案例中心',
      metaName:'广州市熵达贸易有限公司-案例中心',
      metaContent:'广州市熵达贸易有限公司-案例中心',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },
      concatArr: [
        {
          text: 'location',
          icon_src: require('@/assets/images/concat/home.png')
        },
        {
          text: '(+86) 136 7078 1026',
          icon_src: require('@/assets/images/concat/phone.png')
        },
        {
          text: '584595327@qq.com',
          icon_src: require('@/assets/images/concat/email.png')
        },
        {
          text: '(+86) 136 7078 1026',
          icon_src: require('@/assets/images/concat/fax.png')
        },
      ],  
      activeItem:'pc',
      lastRowBlankColumn:0,
      caseData:[
          {
              id:1,
              title:'香港医务检测中心',
            //   title:`${this.$t('case.case_title_1')}`,
              desc:'专业、全面的一站式基因检测服务',
              img_src: require('@/assets/images/case/yiwu.png'),
              type:'pc端'
          },
          {
              id:2,
              title:'香港卓信医疗化验所',
              desc:'更高质素、更方便的基因检测科技',
              img_src: require('@/assets/images/case/zhuoxin.png'),
              type:'pc端'
          },
          {
              id:3,
              title:'香港万利分子检验中心',
              desc:'专业、准确、可靠的基因检测服务',
              img_src: require('@/assets/images/case/wanli.png'),
              type:'pc端'
          },
          {
              id:4,
              title:'香港卓信医疗化验所',
              desc:'更高质素、更方便的基因检测科技 ',
              img_src: require('@/assets/images/case/yiliaohuagong.png'),
              type:'pc端'
          },
          {
              id:5,
              title:'报告系统',
              desc:'香港卓信医疗化验所报告系统 ',
              img_src: require('@/assets/images/case/baogaoxitong.png'),
              type:'pc端'
          },
          {
              id:6,
              title:'工作系統',
              desc:'香港化驗所有限公司工作系统 ',
              img_src: require('@/assets/images/case/gongzuoxitong.png'),
              type:'pc端'
          },
          {
              id:7,
              title:'友易家',
              desc:'友易家业主   友易家用户 ',
              img_src: require('@/assets/images/case/youyijia.png'),
              type:'小程序'
          }, 
          {
              id:8,
              title:'善食商城',
              desc:'致力打造最专业的社区生鲜服务平台 ',
              img_src: require('@/assets/images/case/shanshi.png'),
              type:'app'
          },
      ],
      windowWidth:document.documentElement.clientWidth,
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    },
    'lastRowBlankColumn':function(nval,oval){
        this.resize();
    }
  },
  methods: {
     resize() {
        // 以card父元素的宽为参考
        const dom = this.$refs.cardListWrap;
        let domWidth = dom.offsetWidth;
        // 最少2列
        let columnNo = 1;

        if (domWidth > 500 && domWidth < 700) {
        // 3列
            columnNo = 2;
        }
        else if (domWidth >= 1020 && domWidth <= 1200) {
        // 3列
            columnNo = 3;
        }
        else if(domWidth>1200 &&domWidth<1340){

            columnNo = 4;
        }
         else if (domWidth >= 1340 && domWidth < 1660) {
        // 4列
            columnNo = 4;
        } else if (domWidth >= 1660) {
        // 最多4列
            columnNo = 4;
        }
        // 分页器有选择一页多少个的配置
        // 新增card的块
        // totalBlock是关于这部分的计算，计算当前页总共有几个card
        const totalBlock =this.caseData.length>0?this.caseData.length:10;
        
        // lastRowBlankColumn是计算最后一行需要补几个空白块
        this.lastRowBlankColumn =totalBlock % columnNo > 0 ? columnNo - (totalBlock % columnNo) : 0;
        console.log('this.lastRowBlankColumn',this.lastRowBlankColumn,columnNo,totalBlock,domWidth)
        this.$forceUpdate();
    },
    clickItem(val){
        this.activeItem=val;
    },
  },
  created () {
  },
  mounted () {
      let that=this;
      that.lastRowBlankColumn=1;
      window.onresize=()=>{
          console.log('进来了l')
          that.resize()
      }
  },
  //注销window.onresize事件
  destroyed(){
    window.onresize = null;
  }
}
</script>
<style lang='scss' scoped>
.header_img{
  width: 100%;
  height: 300px;
//   padding-top: 96px;
//   padding-left: 31px;
  background: url('~@/assets/images/case/case_top.png') no-repeat;
  background-size: 100% 100%;
  text-align: left;
}
.case_content{
    padding-left:20px;
    padding-right: 20px;
    text-align: center;
    // width: 70%;
    // margin:auto;
    margin-top:105px;
    .case_title_tip{
        text-align: center;
        font-family: MicrosoftYaHei-Bold;
        font-size: 30px;
        font-weight: bold;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
    }
    .case_title_tip_t{
        margin-top:18px;
        font-family: MicrosoftYaHei;
        font-size: 21px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #999999;
        margin-bottom:78px;
    }
    .case_title_btn_group{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom:78px;
        .pc_btn{
            width: 120px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            color:#333333;
            font-size:16px;
            cursor: pointer;
        }
        .small_min_btn{
            margin-left:100px;
            width: 120px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            color:#333333;
            font-size:16px;
            cursor: pointer;
        }
        .active_btn{
            
            background-color: #0572cc;
            border-radius: 6px;
            color:#ffffff;
        }
    }
    .case_flex_card{
        display: flex;
        justify-content: center;
        align-items: center;
        width:80%;
        margin:auto;
        margin-bottom:30px !important;
        .case_item{
            display:flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
            .item_info{
                width: 370px;
                margin-left:50px;
                // margin-right:50px;
                margin-bottom:74px;
                .image_card{
                    display: flex;
                    width: 100%;
                    height: auto;
                    margin-top:-3px;
                    cursor: pointer;
                }
            }
        }
      
    }
    .card_content{
        margin-top:32px;
        padding-left:22px;
        padding-right:22px;
        display: flex;
        justify-content: start;
        align-items: left;
        flex-direction: column;
        text-align: left !important;
        .card_title{
            font-family: MicrosoftYaHei-Bold;
            font-size: 22px;
            font-weight: bold;
            letter-spacing: 0px;
            color: #333333;
            margin-bottom: 16px;
            cursor: pointer;
        }
        .card_title_t{
            margin-bottom:38px;
            color: #999999;
            cursor: pointer;
            font-size:18px;
        }
    }
    .card_desc{
        margin-bottom:20px;
        text-align: right !important;
        margin-right: 18px;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
     .desc_text{
        width: 80px;
        height: 36px;
        background-color: #ffffff;
        border-radius: 10px 0px 10px 0px;
        border: solid 1px #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        cursor: pointer;
     }
    }           
}
</style>
<style>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
   
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 500px){
   .case_flex_card{
        width:90% !important;
        margin:auto !important;
        text-align: center  !important;
    }

    .item_info{
        margin-left:0px !important;   
       
       width:480px !important;
    }
}
@media (min-width: 500px) and  (max-width: 750px){
   .case_flex_card{
        width:90% !important;
        margin:auto !important;
        text-align: center  !important;
    }

    .item_info{
        /* margin-left:0px !important; */
        
    }
}
@media (min-width: 750px) and (max-width: 860px){

}
@media (min-width: 860px) and (max-width:1200px){
  
    .case_flex_card{
        width:70% !important;
        margin:auto !important;
        text-align: center  !important;
    }
}
@media (min-width: 1780px){                  
  
    .case_flex_card{
        width:70% !important;
        margin:auto !important;
        text-align: center  !important;
    }
 
}
@media (min-width: 1200px) and (max-width:1280px){
  
    .case_flex_card{
        width:80% !important;
        margin:auto !important;
        text-align: center  !important;
    }
}
@media (min-width: 1270px) and (max-width: 1450px){                  
  
    .case_flex_card{
        width:85% !important;
        margin:auto !important;
        text-align: center  !important;
    }
 
}
@media (min-width: 1450px) and (max-width: 1780px){                  
  
    .case_flex_card{
        width:77% !important;
        margin:auto !important;
        text-align: center  !important;
    }
 
}

.el-card{
	box-shadow: 0px 0px 40px 0px #e4eaef !important;
	border-radius: 10px !important;
	background-color: #ffffff !important;
    border:0px solid #ffffff !important;
	/* border-radius: 10px 10px 0px 0px !important; */
}
</style>



// WEBPACK FOOTER //
// src/view/case/index.vue